module.exports = __webpack_public_path__ + "static/media/arcane_growth.bf78418f.png";